// @flow
import * as React from 'react';

import { bind } from '@ta/common.api';

import MobileSeoFooterLinksContainer from './MobileSeoFooterLinksContainer';
import styles from './MobileSeoFooterLinks.less';

const BREADCRUMBS_ENDPOINT = '/data/1.0/breadcrumbs';
const ONPAGE_FACTORS_ENDPOINT = '/data/1.0/onpagefactors';

type Props = {
  mastheadH1: any,
  breadcrumbs: any,
  isMobile: boolean,
  servletName: string,
};

const MobileSeoFooterLinks = (props: Props) => {
  const isMobileTourism = props.servletName === 'MobileTourism' && props.isMobile;
  return (
    <div className={`${isMobileTourism ? styles.containerMarginTop : ''}`}>
      {props.isMobile && props.breadcrumbs && Object.keys(props.breadcrumbs).length > 0 && (
        <MobileSeoFooterLinksContainer
          breadcrumbs={props.breadcrumbs}
          mastheadH1={props.mastheadH1}
        />
      )}
    </div>
  );
};

// $FlowFixMe92
export default bind((state, stage) => {
  const locationId = state.page.geoId;
  if (!locationId) {
    return () => ({});
  }

  const { meta } = state;
  const servletName = (meta && meta.initialServletName) || '';

  const breadcrumbHandle = stage(`${BREADCRUMBS_ENDPOINT}/${locationId}`);
  const opfsHandle = stage(
    `${ONPAGE_FACTORS_ENDPOINT}/basic?servletName=${servletName}&locationId=${locationId}`,
  );

  const breadcrumbResult = breadcrumbHandle && breadcrumbHandle.get();
  const normalBreadcrumbs = breadcrumbResult && breadcrumbResult.data;
  const reversedBreadcrumbs =
    normalBreadcrumbs &&
    [...normalBreadcrumbs].filter(crumb => crumb.href && crumb.href.length > 0).reverse();

  const opfResult = opfsHandle && opfsHandle.get();
  const headerText = opfResult && opfResult.data && opfResult.data.mastheadH1;

  return () => ({
    breadcrumbs: reversedBreadcrumbs,
    mastheadH1: headerText,
    isMobile: state.meta.device.viewportCategory === 'MOBILE',
    servletName,
  });
})(MobileSeoFooterLinks);
